module.exports = __webpack_public_path__ + "static/N2N0s-abe2d76488d74524187dca1b0d22c60b.jpg";